<template>
  <span v-if="errors.has(name)"
    class="help is-danger">{{ errors.first(name) }}</span>
</template>

<script>
export default {
  props: ['name'],
  inject: ['$validator']
}
</script>



// WEBPACK FOOTER //
// src/components/input-error.vue